import React from 'react';
import { Link, useHistory } from 'react-router-dom';

import './Header.css';
import CancelIcon from '../Icon-SVG/CancelIcon';

const Header = ({ name, search, setSearch }) => {
  const history = useHistory();
  return (
    <div className="header">
      <div className="headerInner">
        {search && history.location.pathname === '/search' ? (
          <>
            <p style={{ marginLeft: 10 }}>Search</p>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div className="plus-block" onClick={() => setSearch(false)}>
              <Link to="/rooms" className="plus">
                <CancelIcon />
              </Link>
            </div>
          </>
        ) : (
          <p style={{ marginLeft: 10 }}>{name}</p>
        )}
        {history.location.pathname === '/rooms' && (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
          <div className="plus-block" onClick={() => setSearch(true)} />
        )}
      </div>
    </div>
  );
};

export default Header;
